import { create } from 'zustand'

export const useArtistSongsStore = create(set => ({
  artistName: null,
  options: [
    { id: 'recent', text: 'last updated' },
    { id: 'published', text: 'published date' },
    { id: 'alphabet', text: 'A-Z' },
  ],
  selectedOption: {
    id: 'recent',
    text: 'last updated',
  },
  syncOptions: [
    { id: 'all', text: 'all' },
    { id: 'true', text: 'synced' },
    { id: 'false', text: 'unsynced' },
  ],
  selectedSyncOption: { 
    id: 'all', 
    text: 'all' 
  },
  setSelectedSyncOption: newOption => set({ selectedSyncOption: newOption }),
  searchTerm: '',
  inputValue: '',
  setArtistName: newName => set({ artistName: newName }),
  setSelectedOption: newOption => set({ selectedOption: newOption }),
  setSearchTerm: newText => set({ searchTerm: newText }),
  setInputValue: newText => set({ inputValue: newText }),
}))